// extracted by mini-css-extract-plugin
module.exports = {"comparisonReviewsWrapper":"_f9230f","lazyLoading":"_85f033","comparisonReviewsIntro":"_604a7c","reviewCardWrapper":"_476ba7"};